<template>
  <div class="c-grid">
    <div class="c-grid__items">
      <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__7 u-marginAuto">
        <section class="p-box">
          <div class="p-box__body">
            <div class="initial-registration">
              <p class="c-img-logo">
                <img :src="imgLogoBlack">
              </p>

              <slot />
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import ImgLogoBlack from '../../../images/common/logo_black.svg'
export default {
  name: 'RegistrationLayout',
  data() {
    return {
      imgLogoBlack: ImgLogoBlack,
    }
  },
}
</script>

<style lang="scss" scoped>
.initial-registration {
  text-align: center;
  margin-top: 56px;
}
.c-img-logo {
  margin-left: auto;
  margin-right: auto;
  width: 160px;
  margin-bottom: 40px;
}
</style>
